import { mapValues } from "lodash";
import { unescape } from "validator";

const unescapeObjectValues = <T extends object, Key extends keyof T>(
  obj: T,
  keysToBeUnescaped: Key[]
) => {
  const newObj = mapValues(obj, (value, key: Key) => {
    if (value && typeof value === "string" && keysToBeUnescaped.includes(key)) {
      return unescape(value);
    }
    return value;
  });

  return newObj as T;
};

export { unescapeObjectValues };
